import { Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';
import { UiModule } from '@app/ui';

@Component({
  standalone: true,
  selector: 'sbnb-ruleset-delete-prompt',
  templateUrl: './ruleset-delete-prompt.component.html',
  styleUrls: ['./ruleset-delete-prompt.component.scss'],
  imports: [UiModule, MatDialogModule],
})
export class RulesetDeletePromptComponent {
  private segmentIoService = inject(SegmentIoService);
  private dialogRef = inject(MatDialogRef<RulesetDeletePromptComponent>)

  ngOnInit(): void {
    this.segmentIoService.track(SegmentEvent.RuleSetsRemoveAllModal, {});
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
